<div id="container">
  <div class="translations-table flex justify-content-center mb-3">
    <p-table [value]="templates" [tableStyle]="{ 'min-width': '50rem' }">
      <ng-template pTemplate="header">
        <tr>
          <th>Template name</th>
          <th>Language</th>
          <th>Link</th>
          <th>Copy link</th>
          <th>Translated</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-template>
        <tr>
          <td>{{ template.templateName }}</td>
          <td>{{ template.fullLanguageName }}</td>
          <td>
            <a [href]="template.link" target="_blank">{{ template.link }}</a>
          </td>
          <td>
            <i class="bi bi-copy" (click)="copyToClipboard(template.link)"></i>
          </td>
          <td *ngIf="template.translated">
            <i class="bi bi-check-circle-fill"></i>
          </td>
          <td *ngIf="!template.translated">
            <i class="bi bi-x-circle-fill"></i>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="submit-button">
    <button
      class="btn btn-primary"
      (click)="approveTranslations()"
      [disabled]="disableApproveTranslation"
      >
      <span>Approve all translations</span>
    </button>
  </div>
</div>
